module.exports = require('./$.hide');